import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeMount, onBeforeUnmount, ref } from 'vue'
import { emitter } from '@/plugins/emitter'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import { useFormatLocalData } from '@/composables/format-edit/useFormatLocalData'
import {
  createEmptyShokurekishoFormatData,
  provideShokurekishoFormatData,
  type ShokurekishoExampleSentences
} from '@/composables/format-edit/useShokurekishoFormatData'
import {
  provideShokurekishoHistories,
  useShokurekishoHistories
} from '@/composables/format-edit/useShokurekishoHistories'
import ShokurekishoTextareaCard from '@/components/format-edit/shokurekisho/ShokurekishoTextareaCard.vue'
import ShokurekishoSkillsheetJobHistoryCard from '@/components/format-edit/shokurekisho/ShokurekishoSkillsheetJobHistoryCard.vue'
import ShokurekishoPrMessageCard from '@/components/format-edit/shokurekisho/ShokurekishoPrMessageCard.vue'
import ShokurekishoCreateDateCard from '@/components/format-edit/shokurekisho/ShokurekishoCreateDateCard.vue'
import CompletedOutputPanel from '@/components/format-edit/completed/CompletedOutputPanel.vue'
import type { BasicData } from '@/utils/format-edit/basicData'

type PaymentLifecycle = {
  init: (host: unknown) => void
  cleanup: (host: unknown) => void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ShokurekishoSkillsheetEdit',
  props: {
    basicData: null,
    formatId: null,
    currentCardId: null,
    exampleSentences: null
  },
  setup(__props: any, { expose }) {



const { formLib, vm, yagiprimePaymentService } = useHostServices()

const { formatData, saveKey, saveName, changeCount } = useFormatLocalData({
  saveName: 'skillsheet_type',
  saveOtherName: 'rirekisho',
  createEmpty: createEmptyShokurekishoFormatData
})
provideShokurekishoFormatData(formatData)

const histories = useShokurekishoHistories(formatData)
provideShokurekishoHistories(histories)

const mailPdfEnabled = ref(true)
const downloadPdfEnabled = ref(true)
const isSendYagiEmailEnabled = ref(true)

const getMode = computed(() => process.env.VUE_APP_MODE)

function dataChanged() {
  mailPdfEnabled.value = true
  downloadPdfEnabled.value = true
}

const paymentService =
  yagiprimePaymentService as typeof yagiprimePaymentService & PaymentLifecycle

onBeforeMount(() => {
  if (formatData.createDate === null) {
    formatData.createDate = formLib.getToday()
  }
  if (!formatData.skillsToUse) formatData.skillsToUse = []
  if (!formatData.jobHistories) formatData.jobHistories = []
  if (typeof formatData.skills !== 'string') formatData.skills = ''
  if (typeof formatData.intelligence !== 'string') formatData.intelligence = ''
  if (typeof formatData.otherskills !== 'string') formatData.otherskills = ''
  paymentService.init(vm)
  emitter.on('basic-data-changed', dataChanged)
  emitter.on('format-data-changed', dataChanged)
})

onBeforeUnmount(() => {
  emitter.off('basic-data-changed', dataChanged)
  emitter.off('format-data-changed', dataChanged)
  paymentService.cleanup(vm)
})

expose({
  saveName,
  saveKey,
  formatData,
  changeCount,
  addSkillHistory: histories.addSkillHistory,
  addJobHistory: histories.addJobHistory
})

return { __sfc: true,formLib, vm, yagiprimePaymentService, formatData, saveKey, saveName, changeCount, histories, mailPdfEnabled, downloadPdfEnabled, isSendYagiEmailEnabled, getMode, dataChanged, paymentService, ShokurekishoTextareaCard, ShokurekishoSkillsheetJobHistoryCard, ShokurekishoPrMessageCard, ShokurekishoCreateDateCard, CompletedOutputPanel }
}

})